import React, {memo, Suspense} from 'react';
import clsx from 'clsx';
import LinearProgress from '@mui/material/LinearProgress';

import AppContentView from '@crema/core/AppContentView';
import AppFixedFooter from './AppFixedFooter';
import AppHeader from './AppHeader';
import {useLayoutContext} from '../../../utility/AppContextProvider/LayoutContextProvider';
import DefaultLayoutWrapper from './DefaultLayoutWrapper';
import MainContent from './MainContent';
import {LayoutType} from '../../../../shared/constants/AppEnums';
import AppSidebar from './AppSidebar';
import DefaultLayoutContainer from './DefaultLayoutContainer';

// optional: to gate initial render until auth/ability are ready
import {useJWTAuth} from '@crema/services/auth/jwt-auth/JWTAuthProvider';
import {useAbility} from '@crema/utility/hooks';

const DefaultLayout = () => {
  const {footer, layoutType, headerType, footerType} = useLayoutContext();

  const {isLoading: authLoading} = useJWTAuth() || {};
  const ability = useAbility();

  // Ready when auth is done; ability exists (your hook returns a stable object)
  const ready = !authLoading && Boolean(ability);

  return (
    <DefaultLayoutContainer
      className={clsx({
        boxedLayout: layoutType === LayoutType.BOXED,
        framedLayout: layoutType === LayoutType.FRAMED,
      })}
    >
      <DefaultLayoutWrapper
        className={clsx('defaultLayoutWrapper', {
          appMainFooter: footer && footerType === 'fluid',
          appMainFixedFooter: footer && footerType === 'fixed',
          appMainFixedHeader: headerType === 'fixed',
        })}
      >
        <AppSidebar />

        <MainContent>
          <AppHeader />
          <Suspense fallback={<LinearProgress />}>
            {ready ? <AppContentView /> : <LinearProgress />}
          </Suspense>
          <AppFixedFooter />
        </MainContent>
        {/* <AppThemeSetting /> */}
      </DefaultLayoutWrapper>
    </DefaultLayoutContainer>
  );
};

export default memo(DefaultLayout);
